import Vue from "vue";
import Vuex from "vuex";
import { firestore } from "./main";
import { firebaseMutations, firebaseAction } from "vuexfire";
import mapMachine from "./MapMachine";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    anonUID: null,
    currentState: "addPoint",
    welcomeDismissed: false,
    newPoint: null,
    newCenter: null,
    initialZoomLevel: 3,
    zoomLevel: 3,
    initialMapCenter: [47.41322, -1.219482],
    selectedProfileId: null,
    selectedProfile: {},
    profiles: [],
    profilesLoaded: false,
    profileSavingInProgress: false
  },
  getters: {
    profiles(state) {
      return state.profiles;
    },
    currentState(state) {
      return state.currentState;
    },
    welcomeDismissed(state) {
      return state.welcomeDismissed;
    },
    newPoint(state) {
      return state.newPoint;
    },
    newCenter(state) {
      return state.newCenter;
    },
    zoomLevel(state) {
      return state.zoomLevel;
    },
    profilesLoaded(state) {
      return state.profilesLoaded;
    },
    currentUserHasSavedEntry(state) {
      if (state.profiles.length == 0) return false;

      const match = state.profiles.find(p => {
        return p.id === state.anonUID;
      });

      if (match) return true;
      else return false;
    }
  },
  actions: {
    saveData(context, payload) {
      context.commit("setProfileSavingInProgress", true);
      firestore
        .collection("profiles")
        .doc(context.state.anonUID)
        .set(payload.userResponses)
        .then(() => {
          context.commit("setProfileSavingInProgress", false);
          context.commit("transition", { action: "SAVE_SUCCESS" });
        })
        .catch(e => {
          context.commit("setProfileSavingInProgress", false);
        });
    },
    setProfilesRef: firebaseAction(({ bindFirebaseRef, commit }, ref) => {
      bindFirebaseRef("profiles", ref).then(() => {
        commit("setProfilesLoaded", true);
      });
    }),
    setPinsRef: firebaseAction(({ bindFirebaseRef, commit }, ref) => {
      bindFirebaseRef("profiles", ref).then(() => {
        commit("setProfilesLoaded", true);
      });
    }),
    setSelectedProfile(context, payload) {
      // The name of this action is confusing, see similarly named mutation
      const profileId = payload.profileId;
      // Profiles already loaded, use the local data
      if (context.state.profilesLoaded) {
        var match = context.state.profiles.find(p => {
          return p.id === profileId;
        });
        if (match) {
          context.commit("setProfile", match);
        }
      }
      // Profiles not loaded, load this one from Firebase
      else {
        firestore
          .collection("profiles")
          .doc(profileId)
          .get()
          .then(profile => {
            context.commit("setProfile", profile.data());
          });
      }
    }
  },
  mutations: {
    ...firebaseMutations,
    setAnonUID(state, payload) {
      this.state.anonUID = payload.uid;
    },
    dismissWelcome(state, payloyad) {
      state.welcomeDismissed = true;
    },
    centerMap(state, payload) {
      state.newCenter = payload;
    },
    transition(state, payload) {
      const nextState = mapMachine[state.currentState][payload.action];
      if (nextState) {
        state.currentState = nextState;
        console.log("Transitioning to " + nextState);
      } else {
        console.log("Not a valid state transition");
      }
    },
    setPinLatLng(state, payload) {
      state.newPoint = payload.latlng;
    },
    clearPinLatLng(state) {
      state.newPoint = null;
    },
    setProfilesLoaded(state, payload) {
      state.profilesLoaded = payload;
      if (payload == false) {
        state.selectedProfile = {};
      }
    },
    setProfile(state, payload) {
      state.selectedProfile = payload;
    },
    setProfileSavingInProgress(state, payload) {
      state.profileSavingInProgress = payload;
    }
  }
});



// WEBPACK FOOTER //
// ./source/js/store.js